// Utils
import localStorageService from '../utils/services/localStorage/localStorage';

// Constants
const DARK_MODE_SUGGESTION_SHOWN_KEY = 'milanote.dark_mode.suggested';

export const getHasShownDarkModeSuggestion = () => localStorageService.getItem(DARK_MODE_SUGGESTION_SHOWN_KEY) || false;

export const setHasShownDarkModeSuggestion = () => localStorageService.setItem(DARK_MODE_SUGGESTION_SHOWN_KEY, true);
